export interface Analyse {
  name: string;
  tested: number;
  controlled: number;
  test: number;
  control: number;
  difference?: number;
  khi2Tests?: Array<Khi2Test>;
}

export interface Khi2Table {
  trust: Khi2Trust;
  threshold: number;
}

export interface Khi2Test {
  trust: Khi2Trust;
  valid: boolean;
}

export enum Khi2Trust {
  CorrelationNone,
  Correlation900,
  Correlation950,
  Correlation975,
  Correlation990,
  Correlation999
}
